import React, { ReactNode, useMemo } from "react";

import styled from "@emotion/styled";
import shallow from "zustand/shallow";

import FilterGrid from "../../components/FilterGrid";
import { Headline } from "../../components/Headline";
import useStore from "../store";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
    margin-top: 30px;
    margin-bottom: 30px;
`;
const StyledHeadline = styled(Headline)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;


const HeadlineContainer = () => {
    const [selectedSection, data] = useStore(
        (state) => [state.selectedSection, state.data],
        shallow
    );

    const FirstComponent: ReactNode | undefined = useMemo(() => {
        return selectedSection.filter?.firstComponent;
    }, [selectedSection]);

    const TitelButtonComponent: ReactNode | undefined = useMemo(() => {
        return selectedSection?.titleButton;
    }, [selectedSection]);

    return (
        <>
            {data && !selectedSection.dontShowHeader && (
                <Container>
                    {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                    {/*@ts-ignore*/}
                    <StyledHeadline>
                        {selectedSection.groupDisplayName}
                        {TitelButtonComponent && <TitelButtonComponent />}
                    </StyledHeadline>
                    {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                    {/*@ts-ignore*/}
                    {FirstComponent && <FirstComponent />}
                    <FilterGrid />
                </Container>
            )}
        </>
    );
};

export default HeadlineContainer;
